import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageTitle } from "@/components/app/ui";
import { api, errMsg } from "@/lib/api";

export default function AdminUsers() {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const load = () => api.get(`/admin/users?q=${encodeURIComponent(q)}`).then((r) => setItems(r.data));
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [q]); // eslint-disable-line
  const patch = async (id, body) => { try { await api.patch(`/admin/users/${id}`, body); toast.success("User updated"); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div data-testid="admin-users-page">
      <PageTitle title="All users" copy={`${items.length} users across all companies. Disable access, change roles and see last sign-in.`} />
      <Input placeholder="Search name or email" value={q} onChange={(e) => setQ(e.target.value)} className="mb-4 max-w-sm" data-testid="admin-users-search" />
      <div className="card-box overflow-x-auto">
        <Table data-testid="admin-users-table">
          <TableHeader><TableRow><TableHead>User</TableHead><TableHead>Company</TableHead><TableHead>Role</TableHead><TableHead>Verified</TableHead><TableHead>Last login</TableHead><TableHead>Active</TableHead></TableRow></TableHeader>
          <TableBody>{items.map((u) => (
            <TableRow key={u.id} data-testid={`admin-user-row-${u.email}`}>
              <TableCell><div className="font-medium">{u.name}</div><div className="text-xs text-muted-foreground">{u.email}</div></TableCell>
              <TableCell className="text-xs">{u.company_name}</TableCell>
              <TableCell>{u.role === "admin" ? <span className="text-xs font-semibold text-[#7c3aed]">admin</span> : (
                <Select value={u.role} onValueChange={(v) => patch(u.id, { role: v })}><SelectTrigger className="w-28 h-8" data-testid={`admin-user-role-${u.email}`}><SelectValue /></SelectTrigger>
                  <SelectContent>{["owner", "editor", "approver", "viewer"].map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent></Select>)}</TableCell>
              <TableCell className="text-xs">{u.email_verified ? "Yes" : "No"}</TableCell>
              <TableCell className="text-xs">{u.last_login ? new Date(u.last_login).toLocaleString() : "—"}</TableCell>
              <TableCell>{u.role !== "admin" && <Switch checked={!u.disabled} onCheckedChange={(v) => patch(u.id, { disabled: !v })} data-testid={`admin-user-active-${u.email}`} />}</TableCell>
            </TableRow>))}</TableBody>
        </Table>
      </div>
    </div>
  );
}
